import objectsNameTypes from "../../../enums/objectsNameTypes";
import pathRouts from "../../../enums/pathRoute";
import iconsList from "../../ui/icons/iconsList";

export const mapData = {

    teacherHighSchool: {
        Island1: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png"
            },
            link: {
                he: "https://shefi.education.gov.il/top-topics/prevention-of-harm-105/national-safe-surfing-week/",
                ar: "https://shefi.education.gov.il/top-topics/prevention-of-harm-105/national-safe-surfing-week/"
            },
            text: "strengths",
            textImage: iconsList.strengths,
            name: objectsNameTypes.strengths,
        },
        Island4: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=lessonPlans',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=lessonPlans'
            },
            text: "curatorship",
            textImage: iconsList.curatorship,
            name: objectsNameTypes.curatorship,
        },
        Island5: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/learningEvents.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/learningEvents.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=academic',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=academic'
            },
            text: "learningEvents",
            textImage: iconsList.learningEvents,
            name: objectsNameTypes.learningEvents

        },
        Island6: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png"
            },
            link: {
                he: "https://research.google/ai-quests/intl/he_il",
                ar: "https://research.google/ai-quests/intl/ar_il"
            },
            text: "chatAi",
            textImage: iconsList.chatAi,
            name: objectsNameTypes.bina
        },
    },
    teacherElementary: {
        Island1: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png"
            },
            link: {
                he: '/' + pathRouts.CHATALBERT.route,
                ar: '/' + pathRouts.CHATALBERT.route
            },
            text: "trainingCamp",
            textImage: iconsList.albert,
            name: objectsNameTypes.albert,
        },
        Island2: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/championships.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/championships.png"
            },
            link: {
                he: `${window.location.origin}/widget/teacher/myskillz`,
                ar: `${window.location.origin}/widget/teacher/myskillz`
            },
            text: "championships",
            textImage: iconsList.championships,
            name: objectsNameTypes.championships
        },
        Island3: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/games.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/games.png"
            },
            link: {
                he: "https://stemcraft.co.il",
                ar: "https://stemcraft.co.il"
            },
            text: "games",
            textImage: iconsList.games,
            name: objectsNameTypes.games
        },
        Island4: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=lessonPlans',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=lessonPlans'
            },
            text: "curatorship",
            textImage: iconsList.curatorship,
            name: objectsNameTypes.curatorship,

        },
        Island5: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/learningEvents.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/learningEvents.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=academic',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=academic'
            },
            text: "learningEvents",
            textImage: iconsList.learningEvents,
            name: objectsNameTypes.learningEvents

        },
        Island6: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png"
            },
            link: {
                he: "https://research.google/ai-quests/intl/he_il",
                ar: "https://research.google/ai-quests/intl/ar_il"
            },
            text: "chatAi",
            textImage: iconsList.chatAi,
            name: objectsNameTypes.gemini
        },
    },
    highSchoolStudent: {
        Island1: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png"
            },
            link: {
                he: "https://classroom.google.com/",
                ar: "https://classroom.google.com/"
            },
            text: "strengths",
            textImage: iconsList.albert,
            name: objectsNameTypes.strengths
        },
        Island3: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/aiIntro.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/aiIntro.png"
            },
            link: {
                he: "https://research.google/ai-quests/intl/he_il",
                ar: "https://research.google/ai-quests/intl/ar_il"
            },
            text: "aiIntro",
            textImage: iconsList.aiIntro,
            name: objectsNameTypes.aiIntro
        },
        Island4: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=videos',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=videos'
            },
            text: "curatorship",
            textImage: iconsList.curatorship,
            name: objectsNameTypes.curatorship,

        },
        Island6: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png"
            },
            link: {
                he: `${window.location.origin}/widget/student/usefulTools`,
                ar: `${window.location.origin}/widget/student/usefulTools`
            },
            text: "chatAi",
            textImage: iconsList.chatAi,
            name: objectsNameTypes.bina,
        },
    },
    studentIn7thGrade: {
        Island1: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png"
            },
            link: {
                he: "https://classroom.google.com/",
                ar: "https://classroom.google.com/"
            },
            text: "strengths",
            textImage: iconsList.albert,
            name: objectsNameTypes.strengths
        },
        Island3: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/aiIntro.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/aiIntro.png"
            },
            link: {
                he: "https://research.google/ai-quests/intl/he_il",
                ar: "https://research.google/ai-quests/intl/ar_il"
            },
            text: "aiIntro",
            textImage: iconsList.aiIntro,
            name: objectsNameTypes.aiIntro
        },
        Island4: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=videos',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=videos'
            },
            text: "curatorship",
            textImage: iconsList.curatorship,
            name: objectsNameTypes.curatorship,

        },
        Island6: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png"
            },
            link: {
                he: `${window.location.origin}/widget/student/usefulTools`,
                ar: `${window.location.origin}/widget/student/usefulTools`
            },
            text: "chatAi",
            textImage: iconsList.chatAi,
            name: objectsNameTypes.bina,
        },
    },
    elementaryStudent: {
        Island1: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png"
            },
            link: {
                he: '/' + pathRouts.CHATALBERT.route,
                ar: '/' + pathRouts.CHATALBERT.route
            },
            text: "trainingCamp",
            textImage: iconsList.albert,
            name: objectsNameTypes.albert,
        },
        Island3: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/games.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/games.png"
            },
            link: {
                he: "https://stemcraft.co.il",
                ar: "https://stemcraft.co.il"
            },
            text: "games",
            textImage: iconsList.games,
            name: objectsNameTypes.games
        },
        Island4: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=videos',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=videos'
            },
            text: "curatorship",
            textImage: iconsList.curatorship,
            name: objectsNameTypes.curatorship,

        },
        Island5: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/championships.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/championships.png"
            },
            link: {
                he: `${window.location.origin}/myskillz`,
                ar: `${window.location.origin}/myskillz`
            },
            text: "championships",
            textImage: iconsList.championships,
            name: objectsNameTypes.championships
        },
        Island6: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png"
            },
            link: {
                he: "https://research.google/ai-quests/intl/he_il",
                ar: "http://research.google/ai-quests/intl/ar"
            },
            text: "aiIntroElementary",
            textImage: iconsList.chatAi,
            name: objectsNameTypes.aiIntro
        },
    },
    kosherTeacherHighSchool: {
        Island1: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png"
            },
            link: {
                he: "https://shefi.education.gov.il/top-topics/prevention-of-harm-105/national-safe-surfing-week/",
                ar: "https://shefi.education.gov.il/top-topics/prevention-of-harm-105/national-safe-surfing-week/"
            },
            text: "strengths",
            textImage: iconsList.strengths,
            name: objectsNameTypes.strengths,
        },
        Island4: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=lessonPlans',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=lessonPlans'
            },
            text: "curatorship",
            textImage: iconsList.curatorship,
            name: objectsNameTypes.curatorship,

        },
        Island5: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/learningEvents.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/learningEvents.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=academic',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=academic'
            },
            text: "learningEvents",
            textImage: iconsList.learningEvents,
            name: objectsNameTypes.learningEvents

        },
        Island6: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png"
            },
            link: {
                he: "https://research.google/ai-quests/intl/he_il",
                ar: "https://research.google/ai-quests/intl/ar_il"
            },
            text: "chatAi",
            textImage: iconsList.chatAi,
            name: objectsNameTypes.bina
        }
    },
    kosherTeacherElementary: {
        Island1: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/newTrainingCamp.png"
            },
            link: {
                he: '/' + pathRouts.CHATALBERT.route,
                ar: '/' + pathRouts.CHATALBERT.route
            },
            text: "trainingCamp",
            textImage: iconsList.albert,
            name: objectsNameTypes.albert,
        },
        Island4: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/curatorship.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=lessonPlans',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=lessonPlans'
            },
            text: "curatorship",
            textImage: iconsList.curatorship,
            name: objectsNameTypes.curatorship,

        },
        Island5: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/learningEvents.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/learningEvents.png"
            },
            link: {
                he: '/' + pathRouts.CURATORSHIP.route + '?tab=academic',
                ar: '/' + pathRouts.CURATORSHIP.route + '?tab=academic'
            },
            text: "learningEvents",
            textImage: iconsList.learningEvents,
            name: objectsNameTypes.learningEvents

        },
        Island6: {
            image: {
                he: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png",
                ar: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/Ai/map/newMap/chatAi.png"
            },
            link: {
                he: "https://research.google/ai-quests/intl/he_il",
                ar: "https://research.google/ai-quests/intl/ar_il"
            },
            text: "chatAi",
            textImage: iconsList.chatAi,
            name: objectsNameTypes.bina
        }
    }
}
